// Konfigurasi tab produksi + jalur — dipakai oleh ProductionQueue & Detail Nota.
export const PROD_TABS = [
  { key:"Perlu Diperiksa", label:"Perlu Diperiksa", team:"Owner / Admin", roles:["owner","admin"], teamName:null, pics:[] },
  { key:"Mockup",           label:"Mockup",          team:"Mia / Een",     roles:["owner","admin","produksi"], teamName:"Mockup", pics:["Mia","Een"] },
  { key:"Toko",             label:"Toko",            team:"Admin / Toko",  roles:["owner","admin"],            teamName:"Toko",   pics:["Admin"] },
  { key:"Gudang",           label:"Gudang",          team:"Ridho",         roles:["owner","admin","gudang"],   teamName:"Gudang", pics:["Ridho"] },
  { key:"Bordir",           label:"Desain Bordir",   team:"Wawan / Rizal", roles:["owner","admin","produksi"], teamName:"Bordir", pics:["Wawan","Rizal"] },
  // Iter 333 — Operator Bordir (jahit mesin / aplikasi) adalah TEAM BERBEDA dari
  //   team "Bordir" (desainer DST). Dua entry dengan key stage sama ("Bordir") tapi
  //   teamName berbeda. Admin/Owner HANYA lihat entry pertama (via filter `roles.includes`).
  //   Operator Bordir lihat HANYA entry ini (via filter `teamName === operator.team`).
  //   `roles` sengaja kosong agar admin tidak dapat tab duplikat.
  { key:"Bordir",           label:"Bordir",          team:"Operator Bordir", roles:[], teamName:"Operator Bordir", pics:["Operator Bordir"] },
  { key:"Sablon/DTF",       label:"Sablon / DTF",    team:"Ibnu",          roles:["owner","admin","produksi"], teamName:"Sablon/DTF", pics:["Ibnu"] },
  { key:"Mesin Press",      label:"Mesin Press",     team:"Operator Press",roles:["owner","admin","produksi"], teamName:"Mesin Press", pics:["Operator Press"] },
  { key:"Jersey/Sublim",    label:"Jersey / Sublim", team:"Ahmad Rifky",   roles:["owner","admin","produksi"], teamName:"Jersey/Sublim", pics:["Ahmad Rifky"] },
  // Iter 254 — Tab "Finishing" (Ega) DIHAPUS. Setelah tahap produksi terakhir DONE,
  //   produk langsung masuk stage "Selesai" → order_status auto ke "Menunggu Finalisasi"
  //   (Iter 248). Shella/tim Selesai jadi final QC/finalisasi.
  // Iter 247 — Tab "Selesai" (Shella) DIKEMBALIKAN sebagai tab DASHBOARD (bukan antrean
  //   kerja). Menampilkan nota yg produksi sudah Selesai + filter tgl + status pickup.
  //   Tim Selesai (Shella) melakukan penandaan "Diambil" dari sini.
  { key:"Selesai",          label:"Selesai",         team:"Shella",        roles:["owner","admin","produksi"], teamName:"Selesai", pics:["Shella"], isCompletion:true },
];
// Iter 254 — Route UI: hapus "Finishing" dari semua route custom. Tahap produksi
//   terakhir → langsung "Selesai".
export const ROUTE_STAGES_UI = {
  "Bordir": ["Mockup","Gudang","Bordir","Selesai"],
  "Sablon/DTF": ["Mockup","Sablon/DTF","Selesai"],
  "Sablon/DTF + Press": ["Mockup","Gudang","Mesin Press","Sablon/DTF","Selesai"],
  "Sablon (Plastisol)": ["Mockup","Sablon Paralel","Selesai"],
  "Sablon (DTF)": ["Mockup","Sablon Paralel","Mesin Press","Selesai"],
  // Iter 57 — Multi-proses Bordir + Sablon.
  "Bordir + Sablon (Plastisol)": ["Mockup","Persiapan Paralel","Bordir","Sablon Plastisol","Selesai"],
  "Bordir + Sablon (DTF)": ["Mockup","Persiapan Paralel","Bordir","Mesin Press","Selesai"],
  "Jersey/Sublim": ["Mockup","Jersey/Sublim","Selesai"],
  "Polosan Siap Stok": ["Toko","Selesai"],
  // Iter 338 — Polosan Harus Belanja: Rido (Gudang) → Shella finalisasi → pickup.
  "Polosan Harus Belanja": ["Gudang","Selesai"],
  "Polosan Perlu Jahit": ["Gudang","Selesai"],
  "Perlu Diperiksa": ["Perlu Diperiksa","Selesai"],
};
export const ROUTE_CHOICES = ["Bordir","Sablon (DTF)","Sablon (Plastisol)","Bordir + Sablon (DTF)","Bordir + Sablon (Plastisol)","Jersey/Sublim","Polosan Siap Stok","Polosan Harus Belanja","Polosan Perlu Jahit"];
// Iter 44 + Iter 57 — stage paralel: kunci = stage, nilai = daftar tim (track) yang berbagi antrean.
export const PARALLEL_STAGE_TRACKS = {
  "Sablon Paralel": [
    { track: "sablon", team: "Sablon/DTF", label: "Sablon", pic: "Ibnu" },
    { track: "gudang", team: "Gudang",     label: "Gudang", pic: "Ridho" },
  ],
  "Persiapan Paralel": [
    { track: "bordir_design", team: "Bordir",     label: "Desain Bordir", pic: "Wawan / Rizal" },
    { track: "gudang",        team: "Gudang",     label: "Gudang",        pic: "Ridho" },
    { track: "sablon",        team: "Sablon/DTF", label: "Sablon Prep",   pic: "Ibnu" },
  ],
};
export const STAGE_TEAM_LABEL = { "Perlu Diperiksa":"Admin", "Mockup":"Mia / Een", "Toko":"Admin / Toko", "Gudang":"Ridho", "Bordir":"Wawan / Rizal", "Sablon/DTF":"Ibnu", "Sablon Paralel":"Ibnu & Ridho", "Persiapan Paralel":"Wawan, Ridho & Ibnu", "Sablon Plastisol":"Ibnu", "Mesin Press":"Operator Press", "Jersey/Sublim":"Ahmad Rifky", "Finishing":"Ega", "Selesai":"Shella" };

// Iter 400 — Label DIVISI (bukan nama orang) untuk badge di dashboard /
// section "Produksi Hari Ini". `STAGE_TEAM_LABEL` tetap tersedia untuk
// kebutuhan menampilkan PIC. Tidak mengubah data/workflow/logic — hanya mapping
// label tampilan. Tambahkan "Operator Bordir" sebagai divisi tersendiri bila
// ingin dibedakan dari "Desain Bordir" (default stage "Bordir" → "Desain Bordir").
export const STAGE_DIVISION_LABEL = {
  "Perlu Diperiksa": "Perlu Diperiksa",
  "Mockup": "Mockup",
  "Toko": "Admin Toko",
  "Gudang": "Gudang",
  "Bordir": "Desain Bordir",
  "Operator Bordir": "Operator Bordir",
  "Sablon/DTF": "Sablon",
  "Sablon Paralel": "Sablon",
  "Sablon Plastisol": "Sablon",
  "Persiapan Paralel": "Persiapan",
  "Mesin Press": "Mesin Press",
  "Jersey/Sublim": "Jersey",
  "Finishing": "Finishing",
  "Selesai": "Selesai",
};

